import { apiGet, apiPatch } from '@forwardflow/services/Axios/configs'
import { IGetDemoBookingDTO, IUpdateDemoBookingDTO, ResponseSuccess } from '@forwardflow/types'

export class DemoService {
  //Get demo booking by demo Id
  static getDemoBookingById = async (
    id: number
  ) => {
    const data = await apiGet<ResponseSuccess<IGetDemoBookingDTO>>({
      apiPath: `/demo-bookings/${id}`
    })

    return data.data
  }

  // Update demo booking information
  static overrideDemoBookingInfo = async (
    id: number,
    updateData: IUpdateDemoBookingDTO
  ) => {
    const data = await apiPatch<ResponseSuccess<IUpdateDemoBookingDTO>>({
      apiPath: `/demo-bookings/${id}/override-info`,
      data: updateData
    })

    return data.data
  }
}